
export enum PopUpEnum {
    SUCCESS = "success",
    WARNING = "warning",
    ERROR = "error",
}
